//OpcenterPage.jsx
import React, { useState } from "react";
import "./OpcenterPage.css";
import BannerImage from "../../../assets/other_image/sharePoint.jpg"; // Replace with actual Opcenter banner image
import Letsgetintouch from "../../PLMImplementation/BusinessProcessAndChangeManagement/Letsgetintouch";
import Banner from "../SolutionBanner/Banner";
import FloatingContactUs from "../../floting_contact/FloatingContactUs";
import BookDemoSection from "../PolarianALMSolution/BookDemoSection";
import OpcenterOverview from "./OpcenterOverview";
import { NavLink } from "react-router-dom";
import { Helmet } from "react-helmet-async";

/* FAQ data (Opcenter) */
const faqData = [
  {
    question: "What is Siemens Opcenter?",
    answer:
      "Opcenter is Siemens’ Manufacturing Operations Management (MOM) suite that integrates planning, execution, and quality management to optimize manufacturing performance.",
  },
  {
    question: "Can Opcenter support enterprise-scale manufacturing?",
    answer:
      "Yes. Opcenter is cloud-ready, scalable, and integrates with ERP, CRM, and PLM systems to support global enterprises.",
  },
  {
    question: "How does Opcenter improve production quality?",
    answer:
      "By combining real-time monitoring, analytics, and traceability, Opcenter reduces defects, ensures compliance, and maintains consistent product quality.",
  },
  {
    question: "Which industries use Siemens Opcenter?",
    answer:
      "Automotive, aerospace, electronics, life sciences, consumer goods, and other regulated industries.",
  },
  {
    question: "What’s included in Opcenter APS?",
    answer:
      "Advanced planning and scheduling tools, with multiple editions tailored to different complexity levels, plus long-term planning in the Ultimate edition.",
  },
  {
    question: "Is Opcenter suitable for SMEs?",
    answer:
      "Yes. Opcenter can scale to support small, mid-sized, and large enterprises.",
  },
  {
    question: "How long does it take to implement Siemens Opcenter?",
    answer:
      "Timelines vary — smaller implementations can take weeks, while complex enterprise rollouts may take several months.",
  },
];

const FAQItem = ({ question, answer }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="faq-item">
      <button
        className="faq-question"
        onClick={() => setOpen(!open)}
        aria-expanded={open}
      >
        <span>{question}</span>
        <span>{open ? "−" : "+"}</span>
      </button>
      {open && <div className="faq-answer">{answer}</div>}
    </div>
  );
};

const SectionHeader = ({ title, subtitle }) => (
  <header className="section-header">
    <h2 className="section-title">{title}</h2>
    {subtitle && <p className="section-subtitle">{subtitle}</p>}
  </header>
);

const TileGrid = ({ items }) => (
  <div className="tile-grid-3x2">
    {items.map((item, idx) => (
      <article className="feature-tile" key={idx}>
        {item.icon && (
          <div className="tile-icon">
            <img src={item.icon} alt={item.title} width="48" height="48" />
          </div>
        )}
        <h3 className="tile-title">{item.title}</h3>
        <p className="tile-content">{item.content}</p>
      </article>
    ))}
  </div>
);

const OpcenterPage = () => {
  const businessBenefits = [
    "Gain Real-Time Insights with actionable production data for better decision-making.",
    "Streamline Workflows to eliminate bottlenecks and improve operational efficiency.",
    "Ensure Quality Compliance while reducing defects and meeting regulatory standards.",
    "Achieve Full Traceability across supply chains and regulated industries.",
    "Scale Seamlessly for SMEs, mid-sized enterprises, and global manufacturers.",
    "Bridge Design & Production through digital twin technology for higher accuracy.",
    "Drive Continuous Innovation using closed-loop data for smarter problem-solving.",
  ];

const featuredSolutionsItems = [
  {
    icon: "https://img.icons8.com/color/48/manufacturing.png",  // ⭐ APS FIXED
    title: "Advanced Planning & Scheduling (APS)",
    content:
      "Optimize production scheduling and resource planning with advanced APS capabilities — editions from Express to Ultimate, including automation and long-term planning.",
  },
  {
    icon: "https://img.icons8.com/color/48/factory.png",
    title: "Manufacturing Execution System (MES)",
    content:
      "Real-time production monitoring, work order automation, resource management, and compliance-ready traceability.",
  },
  {
    icon: "https://img.icons8.com/color/48/ok--v1.png",  // ⭐ QM FIXED
    title: "Quality Management (QM)",
    content:
      "Reduce defects and maintain compliance with real-time quality monitoring, audit-ready documentation, and analytics-driven improvements.",
  },
  {
    icon: "https://img.icons8.com/color/48/cloud-connection.png",
    title: "Cloud-Native Architecture",
    content:
      "Deploy on public, private, or hybrid cloud with scaling, resilience, and seamless ERP, CRM, and PLM integration.",
  },
];


  const ourSolutionsItems = [
    {
      icon: "https://img.icons8.com/color/48/rocket--v1.png",
      title: "Complete Opcenter Implementation",
      content:
        "Tailored deployments for faster ROI and manufacturing excellence.",
    },
    {
      icon: "https://img.icons8.com/color/48/link--v1.png",
      title: "Enterprise System Integration",
      content:
        "Seamless connections to ERP, CRM, PLM, and legacy systems.",
    },
    {
      icon: "https://img.icons8.com/color/48/design--v2.png",
      title: "Custom Workflow & UI Design",
      content:
        "Align Opcenter workflows and interfaces with your business processes.",
    },
    {
      icon: "https://img.icons8.com/color/48/training.png",
      title: "Role-Based Training",
      content:
        "Empower teams to independently manage and maximize Opcenter.",
    },
    {
      icon: "https://img.icons8.com/color/48/combo-chart--v1.png",
      title: "Process Optimization",
      content:
        "Boost efficiency with KPI-driven continuous improvement strategies.",
    },
    {
      icon: "https://img.icons8.com/color/48/maintenance--v2.png",
      title: "Managed Support & Maintenance",
      content:
        "24/7 monitoring, proactive updates, and expert support.",
    },
  ];

  const whyNextechItems = [
    {
      icon: "https://img.icons8.com/color/48/industrial-scales.png",
      title: "Manufacturing Operations Expertise",
      content: "Deep Siemens Opcenter knowledge across industries.",
    },
    {
      icon: "https://img.icons8.com/color/48/settings--v1.png",
      title: "Tailored Solutions",
      content: "Customized implementations for your unique operational needs.",
    },
    {
      icon: "https://img.icons8.com/color/48/flash-on--v1.png",
      title: "Agile Deployment",
      content: "Faster, smoother rollouts with minimal disruption.",
    },
    {
      icon: "https://img.icons8.com/color/48/share--v1.png",
      title: "Enterprise Integration",
      content: "Seamless ERP, CRM, and PLM ecosystem connectivity.",
    },
    {
      icon: "https://img.icons8.com/color/48/cloud-connection.png",
      title: "Cloud-Native Flexibility",
      content: "Deploy on-premises, in the cloud, or hybrid.",
    },
    {
      icon: "https://img.icons8.com/color/48/line-chart--v1.png",
      title: "Continuous Improvement",
      content: "Future-proof strategies to sustain competitiveness.",
    },
  ];

  return (
    <>
      {/* ✅ Meta Tags for SEO */}
   <Helmet>
      <title>Opcenter Solutions & Services in Pune | Nextech PLM</title>
      <meta name="description" content="Optimize manufacturing operations with Opcenter solutions in Pune, India. Nextech PLM delivers expert services for process excellence." />
      <meta name="keywords" content="Siemens Opcenter Pune, MES implementation India, Opcenter manufacturing solutions, factory floor optimization, manufacturing execution system" />
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      <link rel="canonical" href="https://nextechplm.com/Opcenter" />
      <meta property="og:site_name" content="NexTech PLM Solutions" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content="Opcenter Solutions & Services in Pune | Nextech PLM" />
      <meta property="og:description" content="Optimize manufacturing operations with Opcenter solutions in Pune, India. Nextech PLM delivers expert services for process excellence." />
      <meta property="og:url" content="https://nextechplm.com/Opcenter" />
      <meta name="twitter:title" content="Opcenter Solutions & Services in Pune | Nextech PLM" />
      <meta name="twitter:description" content="Optimize manufacturing operations with Opcenter solutions in Pune, India. Nextech PLM delivers expert services for process excellence." />
</Helmet>

    <main className="opcenter-solution-page">
      <Banner image={BannerImage} heading="Opcenter Solutions" />
      <FloatingContactUs />
      <OpcenterOverview />

     
      {/* Benefits + Quick Links */}
      <section className="section benefits-section">
        <div className="container">
          <div className="row g-4 align-items-center">
            <div className="col-md-6 col-12">
              <div className="benefits-card">
                <h3 className="benefits-heading">
                  Business Benefits of Opcenter with NexTech
                </h3>
                <ul className="benefits-list">
                  {businessBenefits.map((benefit, idx) => (
                    <li key={idx}>
                      <span className="benefit-icon">✔</span> {benefit}
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="col-md-6 col-12 d-flex align-items-center">
              <div className="quick-links">
                <h4>Quick Links</h4>
                <ul>
                  <li>
                    <NavLink to="/teamcenter/plm-document-management">
                      Document Management
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/teamcenter/manufacturing-data-process-management">
                      Manufacturing Data and Process Management
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/teamcenter/product-bom-variability-management">
                      Product BOM and Variability Management
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/teamcenter/community-collaboration">
                      Teamcenter Community Collaboration
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/teamcenter/cloud-implementation">
                      Teamcenter Implementation on Cloud
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/teamcenter/ecad-integration">
                      ECAD Integration
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/teamcenter/mcad-integration">
                      MCAD Integration
                    </NavLink>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <BookDemoSection />

      {/* Other Sections */}
      <section className="section featured-solutions-section">
        <div className="container">
          <SectionHeader
            title="Opcenter Featured Solutions"
            subtitle="Explore key MOM capabilities powering efficiency, quality, and compliance."
          />
          <TileGrid items={featuredSolutionsItems} />
        </div>
      </section>

 {/* Video Promo Section */}
      <section className="video-promo">
        <div className="video-promo-container">
          <div className="video-promo-content">
            <h2 className="video-promo-heading">
              Transform Manufacturing with Siemens Opcenter
            </h2>
            <p className="video-promo-text">
              Experience how Opcenter optimizes production, improves quality, and
              accelerates digital transformation in manufacturing.
            </p>
            <ul className="video-promo-features">
              <li className="feature-item">
                <img
                  src="https://img.icons8.com/color/48/combo-chart--v1.png"
                  alt="Real-time insights"
                  className="feature-icon"
                />{" "}
                Real-time insights and traceability across the enterprise
              </li>
              <li className="feature-item">
                <img
                  src="https://img.icons8.com/color/48/settings--v1.png"
                  alt="Streamlined workflows"
                  className="feature-icon"
                />{" "}
                Streamlined workflows for agility and efficiency
              </li>
              <li className="feature-item">
                <img
                  src="https://img.icons8.com/color/48/shield--v1.png"
                  alt="Compliance"
                  className="feature-icon"
                />{" "}
                Built-in compliance for regulated industries
              </li>
            </ul>
          </div>

          <div className="video-promo-player">
            <div className="video-wrapper">
              <iframe
                src="https://www.youtube.com/embed/E1IoppNaPSk?autoplay=0&rel=0&modestbranding=1"
                title="Siemens Opcenter Solution Overview"
                frameBorder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                loading="lazy"
              ></iframe>
            </div>
            <p className="video-caption">
              Watch how Opcenter drives smarter manufacturing
            </p>
          </div>
        </div>
      </section>




      <section className="section our-solutions-section">
        <div className="container">
          <SectionHeader title="Our Opcenter Services" />
          <TileGrid items={ourSolutionsItems} />
        </div>
      </section>

      <section className="section why-nextech-section">
        <div className="container">
          <SectionHeader title="Why Choose NexTech for Siemens Opcenter?" />
          <TileGrid items={whyNextechItems} />
        </div>
      </section>

      <section className="section faq-section">
        <div className="container">
          <SectionHeader title="Siemens Opcenter FAQs" />
          <div className="faq-container">
            {faqData.map((item, idx) => (
              <FAQItem key={idx} question={item.question} answer={item.answer} />
            ))}
          </div>
        </div>
      </section>

      <Letsgetintouch />
    </main>
</>
  );
};

export default OpcenterPage;
